import { render, staticRenderFns } from "./arrow-right.vue?vue&type=template&id=7415b9b1&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/melissaallen/fuzzco/pretendstore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7415b9b1', component.options)
    } else {
      api.rerender('7415b9b1', component.options)
    }
    module.hot.accept("./arrow-right.vue?vue&type=template&id=7415b9b1&functional=true&", function () {
      api.rerender('7415b9b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/svg/arrow-right.vue"
export default component.exports